export const SET_STATUSES = 'SET_STATUSES'
export const RESET_STATUSES = 'RESET_STATUSES'
